if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"admin": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"src_Components_Pages_EventsListPage_jsx":1,"src_Components_Pages_Integrations_IntegrationsPage_jsx":1,"src_Components_Pages_WidgetPage_jsx":1,"src_Components_Pages_SettingsPage_jsx":1,"src_Components_Pages_Filters_FiltersPage_jsx":1,"vendors-node_modules_quill_dist_quill_snow_css-node_modules_heroicons_react_24_outline_esm_Ch-65c704":1,"src_Components_Pages_EmailTemplates_jsx":1,"src_Components_Pages_SentEmails_jsx":1,"src_Components_Pages_AnalyticsPage_jsx":1,"src_Components_Pages_BookingsPage_jsx":1,"src_Components_Pages_CalendarPage_jsx":1,"src_Components_Pages_PlansPage_jsx":1,"src_Components_Pages_SupportPage_jsx":1,"src_Components_Pages_BrandingPage_jsx":1,"src_Components_CreateEvent_UnifiedEventForm_jsx":1,"src_Components_Pages_Dashboard_jsx":1,"src_Components_Pages_Filters_CreateFilterPage_jsx":1,"src_Components_Pages_Filters_FiltersListPage_jsx":1,"src_Components_Pages_Integrations_ZoomPage_jsx":1,"src_Components_Pages_Integrations_ZoomSettingsPage_jsx":1,"src_Components_Pages_Integrations_StripeIntegrationsPage_jsx":1,"src_Components_Pages_EmailsPage_jsx":1,"src_Components_Pages_GoogleAnalyticsPage_jsx":1,"src_Components_Pages_Integrations_CalendarsPage_jsx":1,"src_Components_Onboarding_OnboardingFlow_jsx":1,"src_Components_Onboarding_SettingsStep_jsx":1,"src_Components_Onboarding_IntegrationsStep_jsx":1,"src_Components_Onboarding_BrandingStep_jsx":1,"src_Components_Onboarding_BillingStep_jsx":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded